import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import NavLinkWrapper from 'base/ui_components/NavLinkWrapper';
import NavBarDivider from 'base/ui_components/NavBarDivider';
import NavLink from 'base/ui_components/NavLink';
import NavFulfillmentIcon from 'base/ui_components/NavFulfillmentIcons';
import { toTitleCase } from 'base/utils/textUtils';
import NavLinkLabel from 'base/ui_components/NavLinkLabel';
import { ALL_ONLINE_ORDERING_FULFILLMENT_METHODS } from 'cart/constants/fulfillmentOptions';

const NavFulfillmentOptions = props => {
  const {
    fulfillmentTimeOrASAPDisplay,
    fulfillmentMethod,
    availableFulfillmentOptions,
    shouldDisplayCart,
    openModal,
    deliveryAddress,
    isClosed
  } = props;

  if (isClosed) {
    return null;
  }

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      flexDirection={{ xs: 'column', md: 'row' }}
      padding={{ xs: '10px 0', md: 'none' }}
    >
      {availableFulfillmentOptions &&
        availableFulfillmentOptions.map(option => (
          <NavLinkWrapper
            handleClick={() => openModal(option)}
            hideOnMobile={fulfillmentMethod !== option}
            key={option}
            dataTestId={`${option}-option`}
          >
            <NavLink highlighted={fulfillmentMethod === option}>
              <NavLinkLabel
                bold
                uppercase
                dark
                highlighted={fulfillmentMethod === option}
              >
                {toTitleCase(option)}
              </NavLinkLabel>
            </NavLink>
            <Box
              display={{ xs: 'flex', md: 'none' }}
              p={'0 0 0 2px'}
              m={'0 -1px 0 0'}
            >
              <NavFulfillmentIcon icon={option} />
            </Box>
          </NavLinkWrapper>
        ))}
      <NavBarDivider />
      {fulfillmentTimeOrASAPDisplay && (
        <NavLinkWrapper handleClick={() => openModal()}>
          <Box display={{ xs: 'none', md: 'flex' }} m={'0 4px 0 0'}>
            <NavFulfillmentIcon icon="time" />
          </Box>
          <NavLink dataTestId="fulfillment-time">
            <NavLinkLabel>{fulfillmentTimeOrASAPDisplay}</NavLinkLabel>
          </NavLink>
        </NavLinkWrapper>
      )}
      {deliveryAddress && (
        <Box display={{ xs: 'none', md: 'flex' }}>
          <NavBarDivider />
          <NavLinkWrapper handleClick={() => openModal()}>
            <Box m={'4px 1px 0 -4px'}>
              <NavFulfillmentIcon icon="address" />
            </Box>
            <NavLink dataTestId="diner-address">
              <NavLinkLabel>{deliveryAddress}</NavLinkLabel>
            </NavLink>
          </NavLinkWrapper>
        </Box>
      )}
      {shouldDisplayCart && <NavBarDivider />}
    </Box>
  );
};

NavFulfillmentOptions.propTypes = {
  fulfillmentTimeOrASAPDisplay: PropTypes.string,
  fulfillmentMethod: PropTypes.string,
  availableFulfillmentOptions: PropTypes.arrayOf(
    PropTypes.oneOf(ALL_ONLINE_ORDERING_FULFILLMENT_METHODS)
  ),
  shouldDisplayCart: PropTypes.bool,
  openModal: PropTypes.func,
  deliveryAddress: PropTypes.string,
  isClosed: PropTypes.bool
};

export default NavFulfillmentOptions;
